// @flow strict-local

const logLevels = {
  none: 0,
  error: 1,
  warn: 2,
  info: 3,
  progress: 3,
  success: 3,
  verbose: 4,
};

export default logLevels;
